/**
 * @module selectors/one
 */

import defaults from './defaults.js'

/**
 * Returns an element, if any, matching the provided selector
 * and optionally a provided target (recommended)
 * @param {String} selector
 * @param {Document|DocumentFragment|Element} target
 * @returns {?Element}
 */
export default (
  selector,
  target = defaults.document
) => {
  return target.querySelector(selector)
}
